<template>
  <section
    class="header-dash d-flex justify-content-center align-items-start flex-column w-100 h-100"
  >
    <h1 class="my-5">{{ isDiagnosis? 'Diagnóstico financeiro':'Meu plano financeiro' }} </h1>

    <main
      class="w-100 h-100 d-flex justify-content-center align-items-center flex-column"
    >
      <iframe
        v-if="isDiagnosis"
        src="https://www.youtube.com/embed/20aFhoFrPEs"
        title="Vídeo para usuários freemium"
        frameborder="0"
        allowfullscreen
        loading="lazy"
        class="responsive-iframe"
      ></iframe>

      <iframe
        v-else
        src="https://www.youtube.com/embed/170ScvhaevY"
        title="Vídeo para usuários premium"
        frameborder="0"
        allowfullscreen
        loading="lazy"
        class="responsive-iframe"
      ></iframe>

      <button
        class="btn-plan mt-3"
        @click="navigateToPlan"
        :disabled="financialPlanInterested"
        :class="{ 'btn-plan-disabled': financialPlanInterested }"
      >
        <span v-if="isDiagnosis">
          Acessar diagnóstico financeiro
        </span>
        <span v-else-if="financialPlanInterested">
          Seu interesse foi registrado. <br>Entraremos em contato em breve.
        </span>
        <span v-else>
          Tenho interesse no plano financeiro
        </span>
      </button>
    </main>
    <Dialog
      :visible="interestInPlanSuccess"
      :style="{ width: '95%', maxWidth: '650px' }" 
      position="center"
      :closable="true"
      :modal="true" 
      :dismissableMask="true"
      :draggable="false"
      @update:visible="interestInPlanSuccess = false"
    >
      <template #header>
        <div class="dialog-header">
          <h2>Sucesso!</h2>
        </div>
      </template>
      <div class="d-flex flex-column align-items-center">
        <p class="text-center">
          Seu interesse foi registrado com sucesso. Um consultor entrará em contato com você em breve.
        </p>
      </div>
    </Dialog>
  </section>
</template>

<script>
import { useAppStore } from "@/store/store.js";
import Dialog from "primevue/dialog";

export default {
  components: {
    Dialog
  },
  data() {
    return {
      cashFlow: 1000,
      preInterviewUrl: process.env.VUE_APP_INTERVIEW_FRONTEND_URL,
      interestInPlanSuccess: false,
    };
  },
  computed: {
    isFreemium() {
      const store = useAppStore();
      let user = store.userResponse?.data?.userInfo;
      if (
        user?.financial_management_active ||
        user?.is_pn_employee ||
        user?.other_running_products || 
        store.hasSubscriptionActive
      ) {
        return false;
      }
      return store.hasFreemiumAccess;
    },
    isDiagnosis() {
      const store = useAppStore();
      let user = store.userResponse?.data?.userInfo;
      let has_finished_pre_interview =  user?.hasFinishedPreInterview || false;
      return this.isFreemium && !has_finished_pre_interview;
    },
    financialPlanInterested() {
      const store = useAppStore();
      let user = store.userResponse?.data?.userFastapp;
      return user?.financial_plan_interest_at || false;
    }
  },
  mounted(){
    this.saveInfoReadDate()
  },
  methods: {
    saveInfoReadDate() {
      const store = useAppStore();
      if(this.isDiagnosis) {
        store.saveInfoReadDate("financial_diagnosis");
      } else {
        store.saveInfoReadDate("financial_planning");
      }    
    },
    navigateToPlan() {
      const store = useAppStore();
      if (this.isDiagnosis) {
        store.goToPreInterview()
      } else {
        store.saveInterestInPlan();
        this.interestInPlanSuccess = true;
      }
    },
  },
};
</script>

<style scoped>
.responsive-iframe {
  width: 100%;
  max-width: 720px;
  height: 405px;
  border: none;
}

.btn-plan {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: #00AD00;
  border: none;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}

.btn-plan:hover {
  background-color: #008d00;
  transform: scale(1.05);
}

.btn-plan-disabled {
  background-color: #cb5540;
  cursor: not-allowed;
}
.btn-plan-disabled:hover{
  background-color: #cb5540 !important;
  transform: none !important;
}


</style>
